/**
 * s3 에 올린 파일 추적이 어려워서 만들었어요
 */
export const VideoAsset = {
  handmade: 'https://s3.marpple.co/marpple_shop/videos/Handmade.mp4',
} as const;
